<ipb-loading></ipb-loading>

<ng-container class="body">
	<router-outlet #routerOutlet="outlet"></router-outlet>
</ng-container>

<ipb-modal />
<ipb-alert-container />
